import { render, staticRenderFns } from "./NoticeMessage.vue?vue&type=template&id=14e8e3bc"
var script = {}
import style0 from "./NoticeMessage.vue?vue&type=style&index=0&id=14e8e3bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports